package navigation.settings.paymentparameter.paymentparameter

import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import cafe.adriel.voyager.koin.koinScreenModel
import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel
import com.essntl.features.paymentparameter.ui.paymentparameter.PaymentParameterEvent
import com.essntl.features.paymentparameter.ui.paymentparameter.PaymentParameterNavigation
import com.essntl.features.paymentparameter.ui.paymentparameter.PaymentParameterScreen
import com.essntl.features.paymentparameter.ui.addeditpaymentparameter.AddEditPaymentParameterEvent
import com.essntl.features.paymentparameter.ui.addeditpaymentparameter.components.AddEditPaymentParameterDialog
import navigation.settings.paymentparameter.addeditpaymentparameter.AddEditPaymentParameterScreenModel
import navigation.utils.NavLinkScreen

class PaymentParameterScreenNav(
    private val onRefresh: (() -> Unit) -> Unit,
) : NavLinkScreen {
    override val defaultTitle: String get() = "Payment"

    @Composable
    override fun Content() {
        val paymentParameterScreenModel = koinScreenModel<PaymentParameterScreenModel>()
        val paymentParameterState by paymentParameterScreenModel.state.collectAsState()

        val addEditPaymentParameterScreenModel = koinScreenModel<AddEditPaymentParameterScreenModel>()
        val addEditPaymentParameterState by addEditPaymentParameterScreenModel.state.collectAsState()

        var openAddEditPaymentParameterDialog by rememberSaveable { mutableStateOf(false) }
        var paymentParameterToEdit by remember { mutableStateOf<PaymentParameterModel?>(null) }

        LaunchedEffect(Unit) {
            paymentParameterScreenModel.onEvent(PaymentParameterEvent.GetPaymentParameters)
            onRefresh {
                paymentParameterScreenModel.onEvent(PaymentParameterEvent.GetPaymentParameters)
            }
        }

        LaunchedEffect(addEditPaymentParameterState.addEditPaymentParameter.isSuccess) {
            if (addEditPaymentParameterState.addEditPaymentParameter.isSuccess) {
                addEditPaymentParameterState.addEditPaymentParameter.data?.let {
                    if (paymentParameterToEdit == null) {
                        paymentParameterScreenModel.onEvent(PaymentParameterEvent.AddPaymentParameter(it))
                    } else {
                        paymentParameterScreenModel.onEvent(PaymentParameterEvent.EditPaymentParameter(it))
                    }
                }
                addEditPaymentParameterScreenModel.onEvent(AddEditPaymentParameterEvent.ClearState)
                openAddEditPaymentParameterDialog = false
                paymentParameterToEdit = null
            }
        }

        PaymentParameterScreen(
            state = paymentParameterState,
            onEvent = paymentParameterScreenModel::onEvent,
            onNavigation = {
                when (it) {
                    is PaymentParameterNavigation.AddPaymentParameter -> {
                        openAddEditPaymentParameterDialog = true
                    }

                    is PaymentParameterNavigation.EditPaymentParameter -> {
                        paymentParameterToEdit = it.p
                        openAddEditPaymentParameterDialog = true
                    }
                }
            },
        )

        AddEditPaymentParameterDialog(
            openDialog = openAddEditPaymentParameterDialog,
            currentPaymentParameter = paymentParameterToEdit,
            state = addEditPaymentParameterState,
            validation = addEditPaymentParameterScreenModel.validation,
            onEvent = addEditPaymentParameterScreenModel::onEvent,
            onDismissRequest = {
                openAddEditPaymentParameterDialog = false
                paymentParameterToEdit = null
            },
        )
    }
}